import { stylesheet } from 'astroturf';
import styled from 'astroturf/react';
import PopupComponent from 'src/components/Popup';
import TextField from 'src/components/TextField';

const ImportResultPopup = styled(PopupComponent)`
  width: 600px;
  left: calc(50% - 300px);
  padding: 20px 60px;
  transition: top 0.25s ease-in-out, max-height 0.25s ease-in-out;
  overflow: auto;
  max-height: 70%;
  top: 15%;

  &.expanded {
    max-height: 95%;
    top: 10%;
  }
`;

const Classes = stylesheet`
  .option-checkbox {
    color: var(--black);
    line-height: 2rem;
  }

  .warning-text {
    color: var(--ph-red-500);
  }

  .warning-text > span {
    text-decoration: underline;
  }

  .buttons-container {
    display: flex;
    justify-content: space-between;
  }
`;

const ConfirmTextField = styled(TextField)`
  input:placeholder-shown {
    font-style: italic;
  }
`;

const LowerSection = styled('div')`
  margin-top: 2rem;
  transition: margin-top 0.25s ease-in-out;

  &.expanded {
    margin-top: 18rem;
  }
`;

const CheckboxContainer = styled('div')`
  width: 90%;
`;

export default {
  CheckboxContainer,
  Classes,
  ConfirmTextField,
  ImportResultPopup,
  LowerSection,
};
